export default {
  consentPicture: `https://s3.ca-central-1.amazonaws.com/orbcare-dev/public/assets/images/consentpicture.png`,
  stripe: 'https://s3.ca-central-1.amazonaws.com/orbcare-dev/public/assets/images/stripe-wordmark.png',
  poweredByStripe: 'https://s3.ca-central-1.amazonaws.com/orbcare-dev/public/assets/images/powered-by-stripe-black.svg',
  termsUrl: 'https://adracare.com/terms-of-service/',
  privacyUrl: 'https://adracare.com/privacy-statement/',
  supportPaymentUrl: 'https://support.adracare.com/hc/en-us/articles/20571787486349',
  supportEmail: 'support@adracare.com',
};
